import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { map, Observable, take } from 'rxjs';

export function createUniqueCaseInsensitiveStringValidator(strings$: Observable<(string | null)[]>): AsyncValidatorFn {
    const uniqueSet$ = mapToLowercaseSet$(strings$);

    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        return uniqueSet$.pipe(
            map((nullableString: Set<string | null>): ValidationErrors | null => {
                if (nullableString.has(control.value?.toLocaleLowerCase() ?? null)) {
                    return { notUnique: true };
                }

                return null;
            }),
            take(1)
        );
    };
}

function mapToLowercaseSet$(prefixes$: Observable<(string | null)[]>): Observable<Set<string | null>> {
    return prefixes$.pipe(
        map(prefixes => prefixes.map(prefix => prefix?.toLocaleLowerCase() ?? null)),
        map(prefixes => new Set(prefixes))
    );
}
